module.exports = __webpack_public_path__ + "static/media/img-app-feature-3.b7ce86ee.png";